export const contactMapper = {
    title: "Contato",
    formTitle: "Entrar em contato",
    formFields: {
        name: { id: "name", type: "text", placeholder: "Nome" },
        email: { id: "email", type: "email", placeholder: "E-mail" },
        message: { id: "message", type: "textarea", placeholder: "Mensagem", rows: 4 }
    },
    submitButton: "Enviar",
    termsText: "Ao enviar este formulário, você confirma que leu e concorda com os Termos e Condições."
};
